import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { Subject } from 'rxjs/Subject';
import { UsersService } from '../../../services/users.service';
import { UtilsService } from '../../../services/utils.service';
import { debounceTime } from 'rxjs/operators';
import AppConstants from '../../../constants/AppConstants';

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.scss']
})


export class UserViewComponent implements OnInit {


  modelChanged: Subject<string> = new Subject<string>();
  roleModelChanged: Subject<string> = new Subject<string>();

  user;
  userId;
  userRoles;
  wishList;
  selectedRoles = {};

  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              private utilsService: UtilsService,
              public snackBar: MatSnackBar, private graphqlService: UsersService) {
    this.modelChanged.pipe(
      debounceTime(1500)
    ).subscribe(model => this.updateUser());

    this.roleModelChanged.pipe(
      debounceTime(1500)
    ).subscribe(model => this.updateUserRole(model));

    route.params.subscribe(params => {
      if (params['id']) {
        this.userId = params['id'];

        this.graphqlService.read(this.userId).subscribe(result => {
          if (result && result.data) {
            this.user = JSON.parse(JSON.stringify(result.data['user']));
            this.utilsService.openSnackBar('Data Loaded !!', '');
          }
        });
      }
    });
  }

  ngOnInit() {
    const that = this;
    that.userRoles = AppConstants.getRoles;
  }

  hasRole(val) {
    const that = this;
    let itHasRole = false;
    for (let i = 0; i < that.userRoles.length; i++) {
      if (that.userRoles[i].value === val) {
        itHasRole = true;
      }
    }
    return itHasRole;
  }

  dataChanged() {
    this.modelChanged.next();
  }

  roleDataChanged(role) {
    this.roleModelChanged.next(role);
  }

  updateUser() {
    const that = this;
    that.utilsService.openSnackBar('Updating user', '');
    that.graphqlService.update(that.user).subscribe(res => {
      if (res.success) {
        this.utilsService.openSnackBar('Data Updated !!', '');
      }

      if (res.errors) {
        this.utilsService.openSnackBar('Error while updating User !!', '');
      }
    });
  }

  updateUserRole(role) {
    const that = this;
    const roleData = { userId: that.user.id, roleId: role.value };
    that.utilsService.openSnackBar('Updating user role', '');
    that.graphqlService.updateUserRole(roleData).subscribe(res => {
      if (res.success) {
        this.utilsService.openSnackBar('User role updated !!', '');
      }
      if (res.errors) {
        this.utilsService.openSnackBar('Error while updating User role !!', '');
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/users/user-view/user-view.component.ts